module.exports = __webpack_public_path__ + "img/login_transit_facility.f9787620.png";